import React from 'react';

/**
 * Components
 */
import LogoComponent from './Logo';
import MainNavigationComponent from './MainNavigation';
import ProfileComponent from './Profile';
import AdditionalNavigationComponent from './AdditionNavigation';

class Header extends React.Component {
  render() {
    const {user, logOut, changeMenu, location, isComplianceRestricted} = this.props;
    return (
      <header id='header' className='_z_index_max'>
        <div className={`main-header _z_index_max ${isComplianceRestricted ? 'compliance-restricted' : ''}`}>
          <LogoComponent />
          {user.token && !isComplianceRestricted && (
            <MainNavigationComponent user={user} location={location} changeMenu={changeMenu} />
          )}
          {user.token && <ProfileComponent user={user} logOut={logOut} />}
        </div>
        {user.token && !isComplianceRestricted && (
          <AdditionalNavigationComponent user={user} location={location} />
        )}
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/app/Routing/Header/index.jsx